import { createStore, Store } from 'redux'

import { ActionType } from './actions'
import rootReducer, { State } from './reducers'

const isServer = typeof window === 'undefined'

export type StoreType = Store<State, ActionType>

export function initializeStore(initialState?: State): StoreType {
  const enhancer = isServer ? undefined : window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

  if (initialState) {
    return createStore(rootReducer, initialState, enhancer)
  } else {
    return createStore(rootReducer, enhancer)
  }
}
